// Field schemas referenced by the source descriptions.
// Extracted from rawConfig.ts as part of Phase 4.4.

export const matrixFields = {
  ConstructionPlanId: {
    label: {
      bg: 'План ИД'
    },
    visible: false,
    editable: false
  },
  MatrixZoneSequence: {
    label: {
      bg: 'Номер по ред зона'
    },
    visible: true,
    editable: true
  },
  MatrixConstrType: {
    label: {
      bg: 'Начин на застрояване'
    },
    visible: true,
    editable: true,
    codedValues: [
      {code: 1, name: 'е'},
      {code: 2, name: 'д'},
      {code: 4, name: 'с'}
    ]
  },
  MatrixKint: {
    label: {
      bg: 'К инт'
    },
    visible: true,
    editable: true
  },
  MatrixZoneVariety: {
    label: {
      bg: 'Разновидност'
    },
    visible: true,
    editable: true
  },
  MatrixZoneTypeId: {
    label: {
      bg: 'Вид зона'
    },
    visible: true,
    editable: true
  },
  MatrixFlooring: {
    label: {
      bg: 'Етажност'
    },
    visible: true,
    editable: true,
    nullable: true
  },
  MatrixSpecParams: {
    label: {
      bg: 'Специфични параметри'
    },
    visible: true,
    editable: true
  },
  MatrixGreenArea: {
    label: {
      bg: 'Минимална озеленена площ'
    },
    visible: true,
    editable: true
  },
  MatrixDensity: {
    label: {
      bg: 'Плътност на застрояване'
    },
    visible: true,
    editable: true
  },
  rownumber: {
    label: {
      bg: ''
    },
    visible: false,
    editable: false
  },
  QuarterId: {
    label: {
      bg: ''
    },
    visible: false,
    editable: false
  },
  Id: {
    label: {
      bg: ''
    },
    visible: false,
    editable: false
  },
  Geometry: {
    label: {
      bg: ''
    },
    visible: false,
    editable: false
  }
}

export const parcelFields = {
  ApprovedDate: {
    label: {
      bg: 'Влязло в сила на'
    },
    visible: true,
    editable: false,
    dateFormat: 'dd.MM.yyyy'
  },
  PlanDate: {
    label: {
      bg: 'Дата на план/изменение'
    },
    visible: true,
    editable: false,
    dateSupportsOffset: true,
    dateFormat: 'dd.MM.yyyy'
  },
  ParcelNumber: {
    label: {
      bg: 'Номер'
    },
    visible: true,
    editable: true
  },
  EKATTE: {
    label: {
      bg: 'EKATTE'
    },
    visible: true,
    editable: false
  },
  SettlementName: {
    label: {
      bg: 'Име на населено място'
    },
    visible: true,
    editable: false
  },
  CadNumbers: {
    label: {
      bg: 'Кадастрални номера'
    },
    visible: true,
    editable: true
  },
  PR1: {
    label: {
      bg: 'Предназначение 1'
    },
    visible: true,
    editable: true
  },
  PR2: {
    label: {
      bg: 'Предназначение 2'
    },
    visible: true,
    editable: true
  },
  PR3: {
    label: {
      bg: 'Предназначение 3'
    },
    visible: true,
    editable: true
  },
  PR4: {
    label: {
      bg: 'Предназначение 4'
    },
    visible: true,
    editable: true
  },
  PR5: {
    label: {
      bg: 'Предназначение 5'
    },
    visible: true,
    editable: true
  },

  ParcelTypeId: {
    label: {
      bg: 'Тип парцел'
    },
    visible: true,
    editable: true
  },
  RegPlanId: {
    label: {
      bg: 'ИД на план'
    },
    visible: false,
    editable: false,
    nullable: true
  },
  OverriddenByRegPlanId: {
    label: {
      bg: 'ИД на план'
    },
    visible: false,
    editable: false,
    nullable: true
  },

  QuarterId: {
    label: {
      bg: 'ИД на план'
    },
    visible: false,
    editable: false,
    nullable: true
  },
  Created: {
    label: {
      bg: 'Създадено на'
    },
    visible: true,
    editable: false,
    nullable: true
  },
  Modified: {
    label: {
      bg: 'Променено на'
    },
    visible: true,
    editable: false,
    nullable: true
  },
  CreatedBy: {
    label: {
      bg: 'Създадено от'
    },
    visible: true,
    editable: false,
    nullable: true
  },
  ModifiedBy: {
    label: {
      bg: 'Променено от'
    },
    visible: true,
    editable: false,
    nullable: true
  },

  ConstructionPlanId: {
    label: {
      bg: 'План ИД'
    },
    visible: false,
    editable: false
  },
  MatrixZoneSequence: {
    label: {
      bg: 'Номер по ред зона'
    },
    visible: true,
    editable: true
  },
  MatrixConstrType: {
    label: {
      bg: 'Начин на застрояване'
    },
    nullable: true,
    visible: true,
    editable: true,
    codedValues: [
      {code: 1, name: 'е'},
      {code: 2, name: 'д'},
      {code: 4, name: 'с'}
    ]
  },
  MatrixKint: {
    label: {
      bg: 'К инт'
    },
    visible: true,
    editable: true
  },
  MatrixZoneVariety: {
    label: {
      bg: 'Разновидност'
    },
    visible: false,
    editable: false
  },
  MatrixZoneTypeId: {
    label: {
      bg: 'Вид зона'
    },
    visible: true,
    editable: true
  },
  MatrixFlooring: {
    label: {
      bg: 'Етажност'
    },
    visible: true,
    editable: true,
    nullable: true
  },
  MatrixSpecParams: {
    label: {
      bg: 'Специфични параметри'
    },
    visible: true,
    editable: true
  },
  MatrixGreenArea: {
    label: {
      bg: 'Минимална озеленена площ'
    },
    visible: true,
    editable: true
  },
  MatrixDensity: {
    label: {
      bg: 'Плътност на застрояване'
    },
    visible: true,
    editable: true
  },
  Area: {
    label: {
      bg: 'Площ (кв.м.)'
    },
    visible: true,
    editable: false,
    nullable: true
  },
  Municipality: {
    label: {
      bg: 'Municipality'
    },
    visible: false,
    editable: false
  },
  Region: {
    label: {
      bg: 'Municipality'
    },
    visible: false,
    editable: false
  }
}

export const siteParcelFields = {...parcelFields}
for (const f in siteParcelFields) {
  ;(siteParcelFields as any)[f] = {...(siteParcelFields as any)[f], editable: false}
}
